import React from 'react';
import PropTypes from 'prop-types';
import {Button, Icon} from 'semantic-ui-react';
import {FormattedMessage} from "react-intl";
import LeadGenFieldPickerModalContainer from 'pages/LeadGenFieldPicker/LeadGenFieldPickerModalContainer';

const LeadGenFieldCreateButtonSection = (props) => (
    <section className="create-button-section">
        <Button key={`createButton-LeadGenField`} onClick={() => {
            props.createClicked(
                props.formProxy.currentBaseResource,
                props.formProxy.parentCurrentResource,
                props.formProxy.fieldPath,
                props.formProxy.resourcePath.slice(0, props.formProxy.resourcePath.length - 1)
            )
        }}>
            <Icon name="plus"/> <FormattedMessage id={'create.button.leadgenfield'}/>
        </Button>
        <LeadGenFieldPickerModalContainer/>
    </section>
);

LeadGenFieldCreateButtonSection.propTypes = {
    createClicked: PropTypes.func
};

export default LeadGenFieldCreateButtonSection;


// WEBPACK FOOTER //
// ./public/components/forms/CustomFields/LeadGenFieldCreateButton.jsx